import { render, staticRenderFns } from "./Pencatatan_PIUtang.vue?vue&type=template&id=bdb8e336"
import script from "./Pencatatan_PIUtang.vue?vue&type=script&lang=js"
export * from "./Pencatatan_PIUtang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports